import { AuthBaseService } from './services/auth/auth-base.service';
import { Component } from '@angular/core';
import { User } from './shared/models/user.model';
import { RequestService } from './services/request.service';
import { VersionCheckService } from './services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'front-end';

  constructor(
    private authBaseService: AuthBaseService,
    private requestService: RequestService,
    private versionCheck: VersionCheckService
  ) {
    if (this.authBaseService.getLocalStorageToken()) {
      this.meusDados();
    } else {
      const urlSearch = new URLSearchParams(window.location.search);
      const tokenQueryString = urlSearch.get('token');
      if (tokenQueryString) {
        this.authBaseService.setLocalStorageToken(tokenQueryString);
        window.history.replaceState({}, document.title, window.location.pathname);
        this.meusDados();
      }
    }
  }

  ngOnInit(): void {
    this.requestService.form.valueChanges.subscribe(() => this.requestService.error = false);
    
    // Checa a versão assim que o app inicia
    this.versionCheck.checkVersion();

    // Checa a cada 5 minutos
    setInterval(() => this.versionCheck.checkVersion(), 5 * 60 * 1000);
  }

  meusDados(): void {
    this.authBaseService.meusDados().subscribe({
        next: (res: User) => {
            this.authBaseService.setLoggedUser(res);
        },
        error: () => {
            this.authBaseService.logout();
        }
    });
  }

}
